module.exports = __webpack_public_path__ + "img/arrow_2.10665fd4.svg";